export default {
  list: [
    {
      title: 'درصدی',
      value: 'PERCENT'
    },
    {
      title: 'مقداری',
      value: 'VALUE'
    }
  ],
  values: {
    PERCENT: 'PERCENT',
    VALUE: 'VALUE'
  }
}